import { UPDATE_TRIPNAME } from '../actions/mytrips';
import {
  SET_PURCHASED_TRIPKEY,
  SET_RECEIPT,
  SET_PAYMENT_IN_PROGRESS,
  UPDATE_TRIP_STATUS,
  UPDATE_LEGS,
  UPDATE_HOTEL_REVIEW,
} from '../actions/payment';

const initialState = {
  purchasedItin: null,
  receiptResponse: null,
  paymentInProgress: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PURCHASED_TRIPKEY:
      return {
        ...state,
        purchasedItin: action.purchaseResponse,
      };

    case SET_RECEIPT:
      return {
        ...state,
        receiptResponse: action.receiptResponse,
      };
    case UPDATE_LEGS:
      return {
        ...state,
        receiptResponse: {
          ...state.receiptResponse,
          AirResponseDetails: {
            ...state.receiptResponse.AirResponseDetails,
            AirLegs: action.airLegs,
          },
        },
      };
    case SET_PAYMENT_IN_PROGRESS:
      return {
        ...state,
        paymentInProgress: action.inProgress,
      };
    case UPDATE_TRIP_STATUS:
      return {
        ...state,
        receiptResponse: state.receiptResponse.map((obj) => ({
          ...obj,
          Status: action.tripStatus,
        })),
      };
    case UPDATE_TRIPNAME:
      return {
        ...state,
        receiptResponse: {
          ...state.receiptResponse,
          TripName: action.tripName,
        },
      };
    case UPDATE_HOTEL_REVIEW:
      return {
        ...state,
        receiptResponse: [
          {
            ...state.receiptResponse[0],
            HotelResponseDetails: [
              ...state.receiptResponse[0].HotelResponseDetails.map((hotelResponse) => {
                if (hotelResponse.HotelId === parseInt(action.HotelReview.Id)) {
                  return { ...hotelResponse, HotelReview: action.HotelReview };
                }
                return hotelResponse;
              }),
            ],
          },
        ],
      };
    default:
      return state;
  }
};
